import { Snackbar, Stack } from "@mui/material";
import HeaderBar from "../Shared/HeaderBar/HeaderBar";
import NavigationBar from "../Shared/NavigationBar/NavigationBar";
import { useState } from "react";
import LogInWithAllScopes from "./LogInWithAllScopes";
import GetAccessTokenWithAllScopes from "./GetAccessTokenWithAllScopes";
import SetDeployment from "./SetDeployment";

export default function DebugPage() {
    const [snackbarMessage, setSnackbarMessage] = useState(null);

    return (
        <>
            <Snackbar
                message={snackbarMessage}
                open={snackbarMessage}
                onClose={() => setSnackbarMessage(null)}
                autoHideDuration={3000}
            />
            <HeaderBar />
            <Stack direction="column" width="100%" justifyContent="center" alignItems="center" gap="1em" marginTop="1em">
                <LogInWithAllScopes />
                <GetAccessTokenWithAllScopes setSnackbarMessage={setSnackbarMessage} />
                <SetDeployment setSnackbarMessage={setSnackbarMessage} />
            </Stack>
            <NavigationBar />
        </>
    );
}
